import { useMutation, useQueryClient } from 'react-query';
import quoterApiInstance from '../../api/quoterApiInstance';
import { QUERY_KEYS, MUTATION_KEYS } from '../../constants/reactQuery';

/**
 * PATCH /my-favorite-plans/:id
 *
 * @param {object} payload  { id, description, data } - mismo body que el POST de
 *   creación (`description` + `data`), con el id fuera del body para la URL.
 */
const updateFavoritePlan = async ({ id, ...body }) => {
    const { data } = await quoterApiInstance.patch(`/my-favorite-plans/${id}`, body);
    return data;
};

/**
 * Actualiza un plan favorito existente.
 *
 * Sólo invalida el detalle del plan (para que una futura reapertura del formulario vea
 * los cambios); ese detalle usa `QUERY_CONFIG` (staleTime 5 min) y no se refresca solo.
 * La lista y las métricas del dashboard NO se invalidan aquí: tras actualizar se navega a
 * `/dashboard`, que refetchea al montar por `DASHBOARD_QUERY_CONFIG`.
 */
export const useUpdateFavoritePlan = (options = {}) => {
    const queryClient = useQueryClient();

    return useMutation(
        MUTATION_KEYS.favoritePlans.update,
        (payload) => updateFavoritePlan(payload),
        {
            ...options,
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(QUERY_KEYS.favoritePlans.detail(variables.id));
                options.onSuccess?.(data, variables, context);
            },
            onError: (error, variables, context) => {
                console.error('Error updating favorite plan:', error);
                options.onError?.(error, variables, context);
            },
        }
    );
};

export default useUpdateFavoritePlan;
